export const ERROR_CONNECT_TOOL_USB =
  "Lỗi kết nối. Vui lòng kiểm tra lại file kết nối và ấn restart lại";
export const ERROR_GET_INFO_USB =
  "Không lấy dc thông tin USB token. Vui lòng kiểm tra lại USB và ấn Recheck";
export const GET_INFO_USB = "Đang lấy thông tin USB token";

export const ISSUE_INVOICE_COMMON_FIELD = {
  PBAN: {
    field: "pban", // Phiên Bản
    type: "text",
    max: 6,
    disabled: true,
    isHide: true,
    required: false,
  },
  TTCHUNG_KHHDON: {
    field: "ttchung_khhdon", // Ký hiệu hóa đơn
    type: "text",
    isKHHD: true,
    max: 6,
    required: true,
  },
  TTCHUNG_KHMSHDON: {
    field: "ttchung_khmshdon", // Ký hiệu mẫu số hóa đơn
    type: "select",
    selectValues: {
      VAT_INVOICE: "1",
      SALE_INVOICE: "2",
      TICKETS_INVOICE: "5",
      DELIVERY_BILL: "6",
    },
    max: 1,
    required: false,
    disabled: true,
  },
  TTCHUNG_SHDON: {
    field: "ttchung_shdon", // Số hóa đơn
    type: "text",
    required: false,
    disabled: true,
  },
  TTCHUNG_NLAP: {
    field: "ttchung_nlap", // Ngày lập
    type: "date",
    required: false,
    disabled: false,
  },
  TTCHUNG_DVTTE: {
    field: "ttchung_dvtte", // Đơn vị tiền tệ
    type: "select",
    max: 3,
    required: true,
  },
  TTCHUNG_TGIA: {
    field: "ttchung_tgia", // Tỷ giá
    type: "number",
    max: 7,
    disabled: true,
    required: false,
  },
  TTCHUNG_THDON: {
    field: "ttchung_thdon", // Tên Hóa Đơn
    type: "text",
    isHide: true,
    max: 100,
    required: false,
  },
  TTCHUNG_MSTTCGP: {
    field: "ttchung_msttcgp", // Mã số thuế tổ chức cung cấp giải pháp hóa đơn điện tử
    type: "text",
    isHide: true,
    max: 14,
    required: false,
  },
  TTChung_TTKhac: {
    field: "ttchung_ttkhac", // Thông tin chung khác
    type: "object",
    max: 255,
    isHide: true,
    required: false,
  },
};

export const ISSUE_INVOICE_SELLER_FIELD = {
  NBAN_TEN: {
    field: "nban_ten", // Tên
    type: "text",
    max: 400,
    disabled: false,
    required: true,
  },
  NBAN_MST: {
    field: "nban_mst", // Mã số thuế
    type: "text",
    isTaxCode: true,
    max: 14,
    disabled: false,
    required: true,
  },
  NBAN_LDDNBO: {
    field: "nban_lddnbo", // Lệnh điều động nội bộ
    type: "text",
    max: 255,
    disabled: false,
    required: true,
  },
  NBAN_DCHI: {
    field: "nban_dchi", // Địa chỉ kho xuất hàng
    type: "text",
    max: 400,
    disabled: false,
    required: true,
  },
  NBAN_HDSO: {
    field: "nban_hdso", // Hợp đồng số
    type: "text",
    max: 255,
    disabled: false,
    required: false,
  },
  NBAN_HVTNXHANG: {
    field: "nban_hvtnxhang", // Họ và tên người xuất hàng
    type: "text",
    max: 100,
    disabled: false,
    required: false,
  },
  NBAN_TNVCHUYEN: {
    field: "nban_tnvchuyen", // Tên người vận chuyển
    type: "text",
    max: 100,
    disabled: false,
    required: false,
  },
  NBAN_PTVCHUYEN: {
    field: "nban_ptvchuyen", // Phương tiện vận chuyển
    type: "text",
    max: 50,
    disabled: false,
    required: true,
  },
  NBAN_TTKHAC: {
    field: "nban_ttkhac", // Thông tin khác
    type: "text",
    isHide: true,
    max: 255,
    disabled: true,
    required: false,
  },
};

export const ISSUE_INVOICE_BUYER_FIELD = {
  NMUA_TEN: {
    field: "nmua_ten", // Tên người nhận hàng
    type: "text",
    max: 400,
    required: true,
  },
  NMUA_MST: {
    field: "nmua_mst", // Mã số thuế
    isTaxCode: true,
    type: "text",
    max: 14,
  },
  NMUA_DCHI: {
    field: "nmua_dchi", // Địa chỉ kho nhận hàng
    type: "text",
    max: 400,
    required: true,
  },
  NMUA_HVTNNHANG: {
    field: "nmua_hvtnnhang", // Họ và tên người nhận hàng
    type: "text",
    max: 100,
  },
  //   SEND_MAIL: {
  //     field: "send_mail", // Địa chỉ thư điện tử
  //     type: "checkbox",
  //     isEmail: true,
  //     max: 50,
  //   },
  NMua_TTKhac: {
    field: "nmua_ttkhac", // Thông tin khác
    type: "text",
    max: 255,
    isHide: true,
    require: false,
  },
};

// Danh sách hàng hóa dịch vụ
export const ISSUE_INVOICE_HHDV_FIELD = {
  HHDV_OBJ: {
    field: "hhdv_obj",
    type: "field_array",
    fieldReal: "listInvoiceDetail",
    list: {
      TCHAT: {
        field: "tchat", // Tính chất
        fieldReal: "tchat",
        type: "select",
        selectValues: {
          GOODS: "1", // hàng hóa dịch vụ
          PROMOTION: "2", // khuyến mãi
          DISCOUNT: "3", // chiết khấu thương mại
          EXPLAIN: "4", // Ghi chú diễn giải
        },
        max: 1,
        width: "350px",
        required: true,
      },
      STT: {
        field: "stt", // Số thứ tự
        fieldReal: "stt",
        type: "number",
        isHide: true,
        required: false,
        max: 4,
      },
      MHHDVU: {
        field: "mhhdvu", // Mã hàng hóa, dịch vụ
        fieldReal: "mhhdvu",
        type: "select",
        max: 50,
        width: "200px",
        allowCreate: true,
        required: false,
      },
      THHDVU: {
        field: "thhdvu", // Tên hàng hóa, dịch vụ, diễn giải
        fieldReal: "thhdvu",
        // type: "text",
        max: 500,
        width: "300px",
        type: "select",
        allowCreate: true,
        required: true,
      },
      DVTINH: {
        field: "dvtinh", // Đơn vị tính
        fieldReal: "dvtinh",
        type: "text",
        max: 50,
        width: "300px",
        required: false,
      },
      SLUONG: {
        field: "sluong", // Số lượng
        fieldReal: "sluong",
        type: "number",
        width: "200px",
        isThousandSeparator: true,
        max: 21,
        required: false,
      },
      DGIA: {
        field: "dgia", // Đơn giá
        fieldReal: "dgia",
        type: "number",
        width: "200px",
        isThousandSeparator: true,
        max: 21,
        required: false,
      },
      //   TLCKHAU: {
      //     field: "tlckhau", // Tỷ lệ % chiết khấu
      //     fieldReal: "tlckhau",
      //     type: "number",
      //     isThousandSeparator: true,
      //     width: "200px",
      //     maxValue: 100,
      //     required: false,
      //   },
      //   STCKHAU: {
      //     field: "stckhau", // Số tiền chiết khấu
      //     fieldReal: "stckhau",
      //     type: "number",
      //     isThousandSeparator: true,
      //     width: "200px",
      //     max: 21,
      //     required: false,
      //   },
      //   TSUAT: {
      //     field: "tsuat", // Thuế suất
      //     fieldReal: "tsuat",
      //     type: "select",
      //     width: "200px",
      //     allowCreate: true,
      //     isShowWithPageView: [
      //       issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE,
      //       issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE,
      //       issueInvoicePageViewList.PAGE_INVOICE_TICKETS_HAVE_CODE,
      //       issueInvoicePageViewList.PAGE_INVOICE_TICKETS_NONE_CODE,
      //     ],
      //     max: 11,
      //     required: false,
      //   },
      THTIEN: {
        field: "thtien", // Thành tiền
        fieldReal: "thtien",
        width: "300px",
        type: "number",
        isThousandSeparator: true,
        max: 21,
        disabled: true,
        required: false,
      },
      TTKHAC: {
        field: "ttkhac", // Thông tin khác
        fieldReal: "ttkhac",
        type: "text",
        isHide: true,
        required: false,
        max: 255,
      },
    },
  },
};

export const TYPE_INVOICE_ANOTHER = {
  INVOICE_TICKETS: "INVOICE_TICKETS",
  DELIVERY_BILL: "DELIVERY_BILL",
};

export const MODE_INVOICE_ACTION = {
  REPLACE: "REPLACE",
  ADJUST: "ADJUST",
};

export const TYPE_ADJUST_INVOICE = {
  INCREASE: 1,
  DECREASE: 2,
  CHANGE_INFO: 3,
};
